import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/judo';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-58" data-mp="e3nc9t4kka22">
      <div className="mx-auto max-w-6xl" data-id="element-59" data-mp="9mi7cokbb81">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-60" data-mp="598t3fgx4fdo">
          <div className="lg:col-span-7" data-id="element-61" data-mp="574ikeoiki4f">
            <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-62" data-mp="3mgui3zgpqpwo">Co zmienia JUDO GOTOWE™</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-63" data-mp="3rgp9s58bbjis">
              Od chaosu na macie do <em className="text-red-700" data-id="element-64" data-mp="3diikvelcctv9">spokoju i pewności.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-65" data-mp="3ig0w5bmtzl6f">
            Wyobraź sobie, że zaczynasz tydzień z treningami już zaplanowanymi. Wiesz, co robić z każdą
            grupą – i masz pod ręką zajęcia minuta po minucie, gry i zabawy, technikę krok po kroku,
            testy sprawności i karty egzaminacyjne.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-66" data-mp="1f8irdyd8d6b2">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-67" data-mp="1t0gtvqcfs3y9" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-68" data-mp="10bjbzoc50961">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-69" data-mp="wb7q6881g2sz">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-70" data-mp="1aba4xll1ug40">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-71" data-mp="15bnrpc580zv7">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-72" data-mp="2lpdy4pjtc080">Bez JUDO GOTOWE™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-73" data-mp="2gqjifwh56rs4">
              Czy to brzmi znajomo?
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-74" data-mp="2oqh3il8nn3sz">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-75" data-mp="2sr111px549fn">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-76" data-mp="2xpuejicfg0ft" />
                  <span data-id="element-77" data-mp="32oxkr6458cpd">
                    <span className="block font-semibold text-slate-900/80" data-id="element-78" data-mp="253jgaecambm6">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-79" data-mp="2f1pdwjr2gvl8">
            <p className="text-sm font-semibold text-red-300" data-id="element-80" data-mp="2jsfku1f556i1">Z JUDO GOTOWE™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-81" data-mp="1md1ocbzabk1v">
              Mniej planowania. Więcej judo.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-82" data-mp="1rajzm90rybd1">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-83" data-mp="1jru1xerbs4tk">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-84" data-mp="1eu0s8bqtcsoj">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-85" data-mp="19vzd21widdic" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-86" data-mp="w31a9uhqkj4r">
          Skup się na dzieciach na macie – a nie na tworzeniu wszystkich materiałów od zera.
        </p>
      </div>
    </section>;
}